// extracted by mini-css-extract-plugin
var _1 = "RentalPortalOverviewCommunicationRow-moduleavatar___Bjbd";
export { _1 as "avatar" }
